/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FetchClientsResponseDto } from '../models/FetchClientsResponseDto';
import type { GetClientDetailResponseDto } from '../models/GetClientDetailResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminClientsService {
    /**
     * Fetch clients (admin)
     * Returns a paginated list of clients for the admin panel.
     *
     * **Search**: by name, email, or phone (partial, case-insensitive).
     *
     * **Filters** (comma-separated values supported via CSV or repeated params):
     * - serviceType: Service type slugs (e.g., personal_trainer,yoga_instructor)
     * - accountStatus: Account statuses (active,inactive,suspended)
     * - location: City/state names (e.g., delhi,mumbai)
     *
     * **Pagination**: page (default: 1), pageSize (default: 10, max: 100).
     * @param search Search by client name, email, or phone (partial, case-insensitive)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page (max 100)
     * @param serviceType Filter by service types (comma-separated slugs). Filters clients who have bookings with experts of these types.
     * @param accountStatus Filter by account status (comma-separated: active,inactive,suspended)
     * @param location Filter by location (comma-separated city/state names)
     * @returns FetchClientsResponseDto Clients fetched successfully
     * @throws ApiError
     */
    public static clientControllerFetchClientsV1(
        search?: string,
        page: number = 1,
        pageSize: number = 10,
        serviceType?: string,
        accountStatus?: string,
        location?: string,
    ): CancelablePromise<FetchClientsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client',
            query: {
                'search': search,
                'page': page,
                'pageSize': pageSize,
                'serviceType': serviceType,
                'accountStatus': accountStatus,
                'location': location,
            },
            errors: {
                403: `Forbidden - Only admins can access client management APIs`,
            },
        });
    }
    /**
     * Get client detail (admin)
     * Returns detailed profile information for a single client including BMI, preferences, primary location, suspension details, and aggregated stats (sessions, bookings, spend).
     * @param id Client's user UUID (users.id)
     * @returns GetClientDetailResponseDto Client detail fetched successfully
     * @throws ApiError
     */
    public static clientControllerGetClientDetailV1(
        id: string,
    ): CancelablePromise<GetClientDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid UUID format`,
                403: `Forbidden - Only admins can access client management APIs`,
                404: `Client not found`,
            },
        });
    }
}
